module.exports = __webpack_public_path__ + "static/shoreditch-artwork.da0bc918.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shoreditch-artwork.jpg
// module id = 447
// module chunks = 35783957827783